import { IoClose } from "react-icons/io5";
import PropTypes from 'prop-types';
import useFetchDetails from '../hooks/useFetchDetails';

const VideoPlay = ({ data, close, media_type }) => {
  const { data: videoData, error } = useFetchDetails(`/${media_type}/${data?.id}/videos`);

  if (error) {
    return (
      <section className='fixed bg-neutral-700 top-0 right-0 bottom-0 left-0 z-40 bg-opacity-50 flex justify-center items-center'>
        <div className='bg-black w-full max-h-[80vh] max-w-screen-lg aspect-video rounded relative'>
          <button onClick={close} className='absolute -right-1 -top-6 text-3xl z-50'>
            <IoClose />
          </button>
          <div className='w-full h-full flex justify-center items-center text-white'>
            Erro ao carregar vídeo
          </div>
        </div>
      </section>
    );
  }

  if (!videoData || !videoData.results || videoData.results.length === 0) {
    return (
      <section className='fixed bg-neutral-700 top-0 right-0 bottom-0 left-0 z-40 bg-opacity-50 flex justify-center items-center'>
        <div className='bg-black w-full max-h-[80vh] max-w-screen-lg aspect-video rounded relative'>
          <button onClick={close} className='absolute -right-1 -top-6 text-3xl z-50'>
            <IoClose />
          </button>
          <div className='w-full h-full flex justify-center items-center text-white'>
            Vídeo não disponível
          </div>
        </div>
      </section>
    );
  }

  const videoTitle = videoData.results[0].title || videoData.results[0].name || "Video Player";

  return (
    <section className='fixed bg-neutral-700 top-0 right-0 bottom-0 left-0 z-40 bg-opacity-50 flex justify-center items-center'>
      <div className='bg-black w-full max-h-[80vh] max-w-screen-lg aspect-video rounded relative'>
        <button onClick={close} className='absolute -right-1 -top-6 text-3xl z-50'>
          <IoClose />
        </button>
        <iframe
          src={`https://www.youtube.com/embed/${videoData.results[0].key}`}
          className='w-full h-full'
          title={videoTitle}
        />
      </div>
    </section>
  );
}

VideoPlay.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  close: PropTypes.func.isRequired,
  media_type: PropTypes.string.isRequired,
};

export default VideoPlay;